let isMathjaxConfig = false; // 用于标识是否配置
const initMathjaxConfig = () => {
  if (!window.MathJax) {
    return;
  }
  MathJax.Hub.Config({
    showProcessingMessages: false, //关闭js加载过程信息
    messageStyle: "none", //不显示信息
    extensions: ["tex2jax.js"],
    jax: ["input/TeX", "output/HTML-CSS", "output/PreviewHTML"], //输出格式配置：latex 解析为 DOM结构
    displayAlign: "left",
    displayIndent: "2em",
    processRefs: true,
    processEnvironments: true, //当为时true，tex2jax不仅会查找内联和显示数学定界符，还会寻找LaTeX环境（\begin{something}...\end{something}），并标记它们以供MathJax处理
    TeX: {
      Macros: {
        RR: "{\\bf R}",
        bold: ["{\\bf #1}", 1],
      },
    },
    tex2jax: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
      ], //行内公式选择符
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ], //段内公式选择符
      skipTags: ["script", "noscript", "style", "textarea", "pre", "code", "a"], //避开某些标签
      ignoreClass: "comment-content", //避开含该Class的标签
      processEscapes: true,
    },
    CommonHTML: { linebreaks: { automatic: true } },
    "HTML-CSS": {
      availableFonts: ["STIX", "TeX"], //可选字体
      showMathMenu: false, //关闭右击菜单显示
      linebreaks: {
        automatic: true, //超长公式换行处理（默认是false不换行）
        width: "80%", //设置换行的点，默认是遇到等号=换行
      },
    },
    SVG: { linebreaks: { automatic: true } },
  });
  isMathjaxConfig = true; // 配置完成，改为true
};
const MathQueue = function (elementClassName) {
  // debugger
  if (!window.MathJax) {
    return;
  }
  if (!isMathjaxConfig) { // 判断是否初始配置，若无则配置。
    initMathjaxConfig()
  }
  // window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, document.getElementById(elementId)]) // 此配置是根据Id来解析
  MathJax.Hub.Queue([
    "Typeset",
    MathJax.Hub,
    document.getElementsByClassName(elementClassName),
  ]); // 此配置是根据获取到的className进行解析
};

export default {
  isMathjaxConfig,
  initMathjaxConfig,
  MathQueue,
};
